import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import Button from "components/CustomButtons/Button.js";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import brandTheme from "brandTheme/Theme";
import { Navigate, useNavigate } from "react-router-dom";
import OtpModal from "views/components/OtpModal/OtpModal";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "55px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  text:{
    fontSize: "20px",
    fontWeight: 600,
    color: brandTheme.primaryColor,
    marginTop: "20%",
    textAlign: "center",
  }
}));

const EstampSanctionLetter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { authToken } = useSelector((state) => state.login.authData);
  const [fileLink,setFileLink] = useState('');
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
      getUserLoanDetails();
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LEAD_ALL_DOCUMENTS_API + leadId + '/documents',
      method:"GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    console.log(result?.data, "API DATA");
    if(result?.data?.sanctionletter){
        setFileLink(result?.data?.sanctionletter);}
    };
    
    const onClickEstamp = async () =>{
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.USER_SANCTION_LETTER_ESIGN_API + leadId + '/part-a',
        method: "GET",
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        setCallInProgress(false);
      } else if (result?.data?.status === "COMPLETED") {
        setCallInProgress(false);
        navigate("/journey/EsignSanctionLetter");
      }else{
        const result = await apiHandler({
          url: endpoint.USER_SANCTION_LETTER_ESIGN_API + leadId + '/part-a',
          method:"POST",
          authToken: authToken,
        });
        setCallInProgress(false);
        if(result?.data?.status === 'OTP_VALIDATION'){
          setTransactionId(result?.data?.transactionId);
          setModalOpen(true);
        }
        else if (result?.data?.signUrls && result?.data?.signUrls?.[0]?.sign_url) {
          openHtmlInNewTab(result.data.signUrls[0].sign_url);
          navigate('/journey/EsignSanctionLetter');
        } else if (result?.data?.error_code) {
          toastUpdate("Error", result?.data?.user_description || "Something went wrong", true);
        }
      }
  }
  const openHtmlInNewTab = (url) => {
    window.open(url);
  };
  const handleOtpSubmit = async(otp) => {
      setCallInProgress(true);
      const result = await apiHandler({
            url: endpoint.USESR_VALIDATE_ESIGN_OTP_API,
            method:"POST",
            authToken: authToken,
            data:{
              txnId: transactionId,
              otp: otp,
            }
          });
      setCallInProgress(false);
      if(result?.data?.error_code) {
        setOtpError(result?.data?.user_description);
      }else{
        navigate("/journey/EsignSanctionLetter");
      }
    };
    const handleResendOtp = async(otp) => {
      setCallInProgress(true);
      const result = await apiHandler({
            url: endpoint.USESR_VALIDATE_ESIGN_RESEND_OTP_API + transactionId,
            method:"PUT",
            authToken: authToken,
          });
      setCallInProgress(false);
      if(result?.data?.error_code) {
        setOtpError(result?.data?.user_description);
      }else{
        toastUpdate("Success", "OTP Resent Successfully", true);
      }
    };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="E-stamp" button1="E-sign" button1click={onClickEstamp} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
              <Grid container className={classes.inputFieldContainer}>
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ position: "relative" }}
                >
      {(fileLink !== "") ? (
            <iframe src={fileLink} style={{
                width: "100%", 
                height: "80vh", 
                border: "none",
                overflow: "auto"
            }}  />
                  ) : (
                     <Grid xs={12} sm={12} md={12} className={classes.text}>Downloading E-stamp Letter</Grid>
                  )}
      </Grid>
      </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {modalOpen &&
        <OtpModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleOtpSubmit}
        onResendOtp={handleResendOtp}
        loading={callInProgress}
        error={otpError}
        classes={classes}
      />
      }
    </Grid>
  );
};

export default EstampSanctionLetter;
